module.exports = __webpack_public_path__ + "img/119.1.a4ff062d.jpg";